import React, { Component } from 'react'
import { Text } from '../../../SPRINTA/atoms/Forms'
import css from './style.css'

const creditCardList = [
    { card: 'visa', test: /^4/, mask: "#### #### #### ####" },
    // { card: 'mastercard', test: /^5/, mask: "#### #### #### ####" },
    { card: 'mastercard', test: /^((2)|(5))/, mask: "#### #### #### ####" },
    { card: 'diners', test: /^((301)|(305)|(36)|(38))/, mask: "#### ###### #####" },
    { card: 'amex', test: /^((34)|(37))/, mask: "#### ###### #####" },
    { card: 'elo', test: /^((401178)|(401179)|(431274)|(438935)|(451416)|(457393)|(457631)|(457632)|(504175)|(627780)|(636297)|(636368)|(636369)|(5067)|(509)|(650)|(651652)|(6550))/,
        mask: "#### #### #### ####"},
    { card: 'aura', test: /^50(?!4175|67|9)/, mask: "####### #######" },
    { card: 'discover', test: /^((6011)|(622)|(64)|(65))/, mask: "#### #### #### ####" },
    // { card: 'aura', test: /^(50)/, mask: "####### #######" },
    // { card: 'elo', test: /^((636368)|(636369)|(438935)|(504175)|(451416)|(636297)|(5067)|(4576)|(4011)|(506699))/, mask: "#### #### #### ####" },
    { card: 'jcb', test: /^(35)/, mask: "#### #### #### ####" },
    { card: 'hipercard', test: /^((38)|(60))/, mask: "#### #### #### ####" },
]


// const creditCardList = [
// { card: 'visa', test: /^4\d{15}$/, mask: "#### #### #### ####" },
// { card: 'mastercard', test: /^((2|5)\d{15})$/, mask: "#### #### #### ####" },
// { card: 'diners', test: /^((301|305|36|38)\d{11,13})$/, mask: "#### ###### #####" },
// { card: 'amex', test: /^((34|37)\d{13})$/, mask: "#### ###### #####" },
// // ✅ Elo ANTES de Aura e Discover + 16 dígitos + BINs principais
// { 
//   card: 'elo', 
//   test: /^(4011(78|79)\d{10}|431274\d{10}|438935\d{10}|451416\d{10}|4573(93|631|632)\d{10}|504175\d{10}|5067\d{12}|509\d{13}|627780\d{10}|636297\d{10}|6363(68|69)\d{10}|65\d{14})$/, 
//   mask: "#### #### #### ####" 
// },
// // ✅ Aura depois, e excluindo Elo (504175 / 5067 / 509xxx)
// { card: 'aura', test: /^50(?!4175|67|9)\d+$/, mask: "####### #######" },
// { card: 'jcb', test: /^(35)\d{14}$/, mask: "#### #### #### ####" },
// { card: 'hipercard', test: /^((38|60)\d{14})$/, mask: "#### #### #### ####" },
// // ⚠️ Discover por último (porque conflita com Elo 65xxxx)
// // (Se você não usa Discover no BR, pode remover)
// { card: 'discover', test: /^((6011|622|64|65)\d+)$/, mask: "#### #### #### ####" },
// ]





export default class AdyenForm extends Component {
    state = {
        creditCard: '',
        band: null,
        mask: "###################"
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props)
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.defaultValue || nextProps.value) {
            this.setState({
                creditCard: nextProps.value || nextProps.defaultValue
            })
        }
    }
    
    handleChange(e) {
        let val = e.target.value
        let band = null
        let mask = this.state.mask

        creditCardList.forEach(item => {
            if(item['test'].test(val)) {
                band = item['card']
                mask = item['mask']
            }
        })

        this.setState({
            creditCard: val,
            band,
            mask
        })
        
        this.props.handleChange(e)
        this.props.handleChangeCardBanner(band)
    }

    render() {
        const { defaultValue, handleChange, value, handleChangeCardBanner, ...other } = this.props

        return (
            <Text
                handleChange={e => this.handleChange(e)}
                value={this.state.creditCard}
                mask={this.state.mask}
                iconRight={(
                            this.state.band &&
                                <span className={`${css.icon} ${css[`icon-${this.state.band}`]}`} />
                            )}
                { ...other }
            />
        )
    }

}


// WEBPACK FOOTER //
// ./src/App/Components/CreditCardInput/index.js